'use strict';

const $ = require('jquery');
const Cookies = require('./cookie');

const breadcrumbsTracking = function (event, catID) {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: event,
            clickedCategory: catID
        });
    }
};

exports.init = function () {
    $('body').on('click', '.clp-breadcrumb-link', function () {
        breadcrumbsTracking('CLPbreadcrumbClicked', $(this).attr('data-breadcrumb-cat-id'));
    });

    $('body').on('click', '.pdp-breadcrumb-link', function () {
        breadcrumbsTracking('PDPbreadcrumbClicked', $(this).attr('data-breadcrumb-cat-id'));
    });
};
